module.exports = __webpack_public_path__ + "static/media/blazewing_boots.bda9629f.png";